import { render, staticRenderFns } from "./yearDangerWaster.vue?vue&type=template&id=c38fb946&scoped=true&"
import script from "./yearDangerWaster.vue?vue&type=script&lang=js&"
export * from "./yearDangerWaster.vue?vue&type=script&lang=js&"
import style0 from "./yearDangerWaster.vue?vue&type=style&index=0&id=c38fb946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38fb946",
  null
  
)

export default component.exports